// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    timespan: {
        id: 'timespan',
        defaultMessage: `
      {years, plural,
				=0 {}
				one {# year}
				other {# years}
			}
      {months, plural,
				=0 {}
				one {# month}
				other {# months}
			}
			{days, plural,
				=0 {}
				one {# day}
				other {# days}
			}
			{hours, plural,
				=0 {}
				one {# hour}
				other {# hours}
			}
			{minutes, plural,
				=0 {}
				one {# minute}
				other {# minutes}
			}
			{seconds, plural,
				=0 {}
				one {# second}
				other {# seconds}
			}`
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/timespan/intl.js